import Alpine from 'alpinejs'
import { jarallax } from 'jarallax';
import initCursor from "./cursor";

window.$ = window.JQuery = require('jquery');
window.Flickity = require('flickity');
window.AOS = require('aos');
window.LazyLoad = require('vanilla-lazyload');
window.Alpine = Alpine;

require('./scroll')
require('./player')

require('./carousels/hero-image-carousel');
require('./carousels/logo-partners-carousel');

import tippy from 'tippy.js';
import { createPopper } from '@popperjs/core';

import header from './components/header'
import projects from './components/projects'
import projectsCarousel from './carousels/projects-row-carousel';
import imageCarousel from './carousels/new/image-carousel'
import multiImageCarousel from './carousels/new/multi-image-carousel.js'
import videoCarousel from './carousels/new/video-carousel'
import videoBlock from './components/video-block'
import videoFeatureBlock from './components/video-feature-block'
import offsetImageCarousel from './carousels/new/offset-image-carousel'
import heroVideoCarousel from './carousels/hero-video-carousel-new'
import caseStudyMetaCarousel from './carousels/projects-case-study-meta-carousel'

Alpine.data('header', header);
Alpine.data('projects', projects);
Alpine.data('heroVideoCarousel', heroVideoCarousel);
Alpine.data('caseStudyMetaCarousel', caseStudyMetaCarousel);
Alpine.data('projectsCarousel', projectsCarousel);
Alpine.data('imageCarousel', imageCarousel);
Alpine.data('videoCarousel', videoCarousel);
Alpine.data('multiImageCarousel', multiImageCarousel);
Alpine.data('videoBlock', videoBlock);
Alpine.data('videoFeatureBlock', videoFeatureBlock);
Alpine.data('offsetImageCarousel', offsetImageCarousel);

// Magic: $tooltip
Alpine.magic('tooltip', el => message => {
    let instance = tippy(el, { content: message, trigger: 'manual' })

    instance.show()

    setTimeout(() => {
        instance.hide()

        setTimeout(() => instance.destroy(), 150)
    }, 2000)
})

// Directive: x-tooltip
Alpine.directive('tooltip', (el, { expression }) => {
    tippy(el, { content: expression })
})

Alpine.start();

initCursor();

$(document).ready(function() {
    AOS.init();

    jarallax(document.querySelectorAll('.jarallax'), {
        speed: 0.6,
        imgSize: 'cover',
        imgPosition: '50% 50%'
    });

    new LazyLoad();
});

/**
 * Smooth scrolling
 */
$('.smooth-scroll')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        if (
            location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
            &&
            location.hostname === this.hostname
        ) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: (target.offset().top - $('header').height() - 10)
                }, 1000, function () {
                    let $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) {
                        return false;
                    } else {
                        $target.attr('tabindex', '-1');
                        $target.focus();
                    }
                });
            }
        }
    });

$('.submit-contact-form').on('click', function(e) {
    e.preventDefault();

    $(document).find('.wpcf7-submit').click();
});

/**
 * Custom Carousel Cursor
 */
$(document).ready(function () {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    if (isMobile) return;

    let mouseX = 0, mouseY = 0;
    let xp = 0, yp = 0;
    const cursorContainer = $('.carousel-cursor-container');
    const hoverElements = $('.hero-video-carousel-instance .flickity-prev-next-button, .hero-video-carousel-instance .flickity-page-dots, .carousel-meta, .navigation, .slide-over-menu, header');

    $(document).mousemove(function (e) {
        mouseX = e.pageX - 30;
        mouseY = e.pageY - 30;
    });

    function animate() {
        xp += (mouseX - xp) / 6;
        yp += (mouseY - yp) / 6;
        cursorContainer.css({left: xp + 'px', top: yp + 'px'});
        requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);

    hoverElements.hover(function () {
        cursorContainer.hide();
    }, function () {
        cursorContainer.css('display', 'flex');
    });
});